import { PatientDetailsDTO } from '../../types/dto/patient';
import { CompletePatient } from '../../types/patients';

export const convertPatientDetails = ({ dateOfBirth, ...rest }: PatientDetailsDTO): CompletePatient => ({
  ...rest,
  dateOfBirth: dateOfBirth ? new Date(dateOfBirth).getTime() : undefined,
});
